import { useMutation } from '@tanstack/react-query'
import { generateScriptById } from 'service/list'

function useGenerateScript(extensionCollectId: number) {
  return useMutation({
    mutationKey: ['generate-script', extensionCollectId],
    mutationFn: generateScriptById,
  })
}

export default useGenerateScript
